import { Injector } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { ApiService } from '@modules/shared/services/api.service';
import { catchError, map } from 'rxjs/operators';
import { getPeruTime } from '@modules/shared/pipes/ro-date';
import * as i0 from "@angular/core";
export class ModuleService extends ApiService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.modules$ = new BehaviorSubject([]);
        this.getModules();
    }
    getModules() {
        return this.get('modules').pipe(catchError(() => of([])), map((modules) => {
            this.modules$.next(modules);
            return modules;
        }));
    }
    moduleIsInactive(module) {
        const { inactive_start_minutes, inactive_end_minutes } = module;
        const now = getPeruTime();
        const startOfDay = now.startOf('day');
        const inactiveStart = startOfDay.add(inactive_start_minutes, 'minutes');
        const inactiveEnd = startOfDay.add(inactive_end_minutes, 'minutes');
        return now.isBetween(inactiveStart, inactiveEnd);
    }
    isModuleAvailable(identifier) {
        return this.modules$.pipe(map((modules) => {
            const currentModule = modules.find((m) => m.identifier === identifier);
            if (!currentModule) {
                return false;
            }
            if (currentModule.inactive_start_minutes === 0 && currentModule.inactive_end_minutes === 0) {
                return true;
            }
            return !this.moduleIsInactive(currentModule);
        }));
    }
}
ModuleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModuleService_Factory() { return new ModuleService(i0.ɵɵinject(i0.INJECTOR)); }, token: ModuleService, providedIn: "root" });
